function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'underscore';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
// import logger from '../utils/logger';

const calculateNewProgress = pendingUploadDocs => {
  const totalFiles = pendingUploadDocs.length;

  // we want to exit out of the the upload progress if all pendingDocs failed
  if (totalFiles === 0) {
    // upload sequence is between 5 and 95% - 95%-100% indicates an attempt to
    // save to the database (if records exist to be saved). Returning 95
    // indicates all upload attempts to S3 have concluded
    return 95;
  }
  const uploadedDocs = _.reduce(pendingUploadDocs, (memo, file) => {
    if (file.uploaded) {
      return memo + 1;
    }
    return memo;
  }, 0);

  // 5% = started (first 5%)
  // 5% - 95% = uploading the docs to S3 (middle 90%)
  // 95% - 100% = save entries to the database (last 5%)
  const newProgress = parseInt(90 * uploadedDocs / totalFiles, 10) + 5;
  return newProgress;
};
export default function changeReducerFactory(entity) {
  const constants = constantsRegistry(entity);

  // REDUCER METHODS

  const uploadAll = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    failedToUpload: [],
    isUploadingImage: true,
    loading: true,
    pendingDocs: action.filesToUpload,
    progress: 5 // 5% indicates that upload has begun - shows progress bar
  });
  const uploadFailure = (state, action) => {
    // don't want to copy the list, we'll add back what's not removed
    const newPendingUploadDocs = [];
    const newFailedToUpload = JSON.parse(JSON.stringify(state.failedToUpload));

    // Only the file byteSize and displayName are retrieved by dropzone
    // We must match that to the list of files in pendingDocs
    state.pendingDocs.forEach(next => {
      if (next.byteSize === action.file.byteSize && next.displayName === action.file.displayName && !next.uploaded) {
        /* eslint-disable-next-line */
        console.log(`Failed to upload '${next.displayName}', adding to failure list.`);
        newFailedToUpload.push(next); // add failed doc to list
      } else {
        newPendingUploadDocs.push(next); // add non-failing doc to list
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      failedToUpload: newFailedToUpload,
      isUploadingImage: false,
      loading: false,
      pendingDocs: newPendingUploadDocs,
      progress: calculateNewProgress(newPendingUploadDocs)
    });
  };
  const uploadSuccess = (state, action) => {
    // copy the pendingDocs so they can be opperated on
    const newPendingUploadDocs = JSON.parse(JSON.stringify(state.pendingDocs));

    // Only the file byteSize and displayName are retrieved by dropzone
    // We must match that to the list of files in pendingDocs
    const dropzoneDocs = newPendingUploadDocs.map(incomingDoc => {
      const next = incomingDoc;
      if (next.byteSize === action.file.byteSize && next.displayName === action.file.displayName && !next.uploaded) {
        delete next.rawFile; // don't want to keep holding on to the raw file
        next.uploaded = true;
      }
      return next;
    });
    // uncomment line below if you want to monitor bulk upload progress
    // console.log('Progress:', calculateNewProgress(dropzoneDocs));

    // logger('newPendingUploadDocs', newPendingUploadDocs);
    return _objectSpread(_objectSpread({}, state), {}, {
      isUploadingImage: false,
      loading: false,
      pendingDocs: newPendingUploadDocs,
      progress: calculateNewProgress(dropzoneDocs)
    });
  };
  const uploadClear = state => _objectSpread(_objectSpread({}, state), {}, {
    failedToUpload: [],
    pendingDocs: [],
    progress: -1,
    // hides progress bar
    lastUploadedDocs: []
  });
  const serverSaving = (state, {
    id,
    setStatus
  }) => {
    // Find the file by id and update it's server save status to active
    const updatedPendingDocs = state.pendingDocs.map(incomingDoc => {
      const next = incomingDoc;
      if (next.id === id && next.savingToServer === !setStatus) {
        // console.log(`${id}: setting save status -> ${setStatus}`);
        next.savingToServer = setStatus;
      }
      return next;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      pendingDocs: updatedPendingDocs
    });
  };

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers: {
      [constants.UPLOAD_ALL]: uploadAll,
      [constants.UPLOAD_CLEAR]: uploadClear,
      [constants.UPLOAD_FAILURE]: uploadFailure,
      [constants.UPLOAD_SUCCESS]: uploadSuccess,
      [constants.SERVER_SAVE_STATUS]: serverSaving
    },
    initState: {
      failedToUpload: [],
      isUploadingImage: false,
      pendingDocs: [],
      progress: -1
    }
  };
}